<div class="plan-card">

	<div class="plan-header">
		<h2 class="plan-title">{{ plan?.pricingTierName}}</h2>
		<p class="plan-subtitle">{{ plan?.description }}</p>
	</div>

	<div class="plan-section">
		<h3 class="section-heading">Includes:</h3>


		<ul class="features-list">
			<li class="core-item">
				<i class="pi pi-check feature-icon"></i>

				<a
					href="https://www.tyalls.com/pricing/#plans"
					target="_blank"
					rel="noopener noreferrer"
					class="core-link"
				>
					Core Features
					<i class="pi external-icon pi-external-link external-icon"></i>
				</a>
			</li>
			<li *ngFor="let f of featureList">
				<i class="pi pi-check feature-icon"></i>
				<span>{{ f }}</span>
			</li>
		</ul>
	</div>

	<div class="plan-footer">
		<p class="plan-note">{{ plan?.footerText}}</p>
	</div>

</div>
